import { memo, useState } from "react";
import Name from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Name/Name";
import Highlight from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Highlight/Highlight";
import Demo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Demo/Demo";
import Actions from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Actions/Actions";
import { FixaInputField } from "@coworker/apprestructured/src/shared/wrappers/FixaInputField/FixaInputField";
import RecursiveTextCardFragment from "@coworker/apprestructured/src/task-management/components/TaskCard/card-fragments/RecursiveTextCardFragment/RecursiveTextCardFragment";
import { Task } from "@coworker/apprestructured/src/task-management/types/Task";
import { TaskType } from "@coworker/apprestructured/src/task-management/types/TaskType";

const REASON_LABELS: Record<string, string> = {
  missing: "articlesAreMissingFromMediaString",
  damaged: "articlesAreDamagedString",
  newPTags: "articlesNeedNewPTagsString",
  remove: "articlesNeedToBeRemovedString",
};

const toReasonKey = (reason: string) => REASON_LABELS[reason] ?? reason;
// Three-step chain: reason → "in location" wrapper → period appended as suffix
function RecursiveTextCardFragmentDemo() {
  const [reason, setReason] = useState("missing");
  const [mediaName, setMediaName] = useState("B1");
  const [prefix, setPrefix] = useState("Before");

  const task = {
    details: {
      reason: toReasonKey(reason),
      mediaName,
      aggregatorValue: prefix,
    },
  } as unknown as Task;
  const taskType = {} as unknown as TaskType;

  return (
    <Demo>
      <Name>RecursiveTextCardFragment</Name>
      <Highlight>
        <RecursiveTextCardFragment
          configProps={{
            steps: [
              { field: "details.reason", format: "translate-field" },
              {
                field: "details.mediaName",
                format: "media-name-appender",
              },
              {
                field: "details.aggregatorValue",
                format: "demo-name-aggregator",
              },
            ],
          }}
          commonProps={{ task, taskType }}
        />
      </Highlight>
      <Actions>
        <FixaInputField
          label="Reason (missing | damaged | newPTags | remove)"
          id="recursive-reason"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          type="text"
        />
        <FixaInputField
          label="Media Name (e.g. B1, B2, C1)"
          id="recursive-media-name"
          value={mediaName}
          onChange={(e) => setMediaName(e.target.value)}
          type="text"
        />
        <FixaInputField
          label="Prefix (e.g. Before, Pre, ...)"
          id="recursive-aggregator-value"
          value={prefix}
          onChange={(e) => setPrefix(e.target.value)}
          type="text"
        />
      </Actions>
    </Demo>
  );
}

export default memo(RecursiveTextCardFragmentDemo);
